import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { SUB_TABS, activeGroupKey, activeSubTabIndex } from '@/components/navConfig';

// Renders a horizontal pill bar at the top of grouped pages. Hidden when the
// current path doesn't belong to a group (e.g. detail pages, the dashboard).
export default function SubTabBar() {
  const { pathname, search } = useLocation();
  const groupKey = activeGroupKey(pathname);
  const tabs = groupKey ? SUB_TABS[groupKey] : null;
  if (!tabs || tabs.length === 0) return null;

  const visible = tabs.filter(
    (t) => !t.previewOnly || window.location.hostname.includes('preview'),
  );
  const activeIdx = activeSubTabIndex(groupKey, pathname, search);

  return (
    <div
      className="sticky top-[52px] z-30 bg-slate-50/95 backdrop-blur-sm border-b border-slate-200/60 px-6 py-2.5 flex flex-wrap items-center gap-1.5"
      data-testid={`subtab-bar-${groupKey}`}
    >
      {visible.map((tab, idx) => {
        const isActive = idx === activeIdx;
        const Icon = tab.icon;
        return (
          <NavLink
            key={tab.to}
            to={tab.to}
            data-testid={`subtab-${groupKey}-${tab.to.slice(1).replace(/\//g, '-')}`}
            className={`shrink-0 inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-full text-xs font-medium transition-all duration-150 ${
              isActive
                ? 'bg-[#00709B] text-white shadow-sm'
                : 'bg-white text-slate-600 border border-slate-200 hover:border-slate-300 hover:text-slate-900'
            }`}
          >
            {Icon && <Icon className="w-3.5 h-3.5" />}
            <span>{tab.label}</span>
          </NavLink>
        );
      })}
    </div>
  );
}
